import { Link } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './index.css'
import { useEffect, useState } from 'react';
export default function MenuNavegacion() {
    const subencabezado_elementos = [{ ruta: '', titulo: "ESTADO DEL TRÁFICO", subrutas: [{ ruta: '/mapa', titulo: "Mapa Estado Tráfico" }, { ruta: '/estado', titulo: "Tabla Estado Tráfico" }] }, { ruta: '/aparcamientos', titulo: "APARCAMIENTOS" }, { ruta: '', titulo: "INCIDENCIAS", subrutas: [{ ruta: '/incidencias', titulo: "Consultar Incidencias" }, { ruta: '/mailto', titulo: "Notificar Incidencia" }] }, { ruta: '/enlaces', titulo: "ENLACES" }]
    const [mail, setMail] = useState( { DESTINATARIO: "", ASUNTO: "", CUERPO: "" })

    useEffect(() => {
        // Cargar el config.json desde la carpeta public
        const loadConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setMail(config.MAIL_INCIDENCIAS)
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const abrirCorreo = () => {
        const destinatario = mail.DESTINATARIO;
        const asunto = encodeURIComponent(mail.ASUNTO);
        const cuerpo = encodeURIComponent(mail.CUERPO);
        window.location.href = `mailto:${destinatario}?subject=${asunto}&body=${cuerpo}`;
    };
    return (
        <ul className="list subencabezado-list">
            {subencabezado_elementos.map(ele =>
                <li key={ele.titulo} className='subencabezado-list-element'>
                    {ele.ruta === '' ? (
                        <>
                            <span style={{display: 'flex', alignItems: 'center'}}>{ele.titulo}<KeyboardArrowDownIcon sx={{width: '25px'}}/></span>
                            {ele.subrutas && 
                                <ul className='subruta'>
                                    {ele.subrutas.map(subruta =>
                                        <li key={subruta.titulo} style={{display: 'flex', alignItems: 'center'}}>
                                            <ArrowForwardIosIcon sx={{width: '15px'}}/>
                                            {subruta.ruta === '/mailto' ? (
                                                <span className='link-subruta' onClick={abrirCorreo}>{subruta.titulo}</span>
                                            ) : (
                                                <Link className='link-subruta' to={subruta.ruta}>{subruta.titulo}</Link>
                                            )}
                                        </li>
                                    )}
                                </ul>
                            }
                        </>
                    ) : (
                        <Link className='link' to={ele.ruta}>{ele.titulo}</Link>
                    )}
                </li>
            )}
        </ul>
    );
}

